import styled from '@emotion/styled';
import { ClassAttributes, createElement } from 'react';

import DummyContent from '../../component/primitive/DummyContent';
import DummyRectangle from '../../component/primitive/DummyRectangle';
import { SPACING_UNIT } from '../../constant/spacing';
import { gridLayoutContainer, gridLayoutItem } from '../../styleUtility/gridLayout';

interface Props {
  className?: string;
}

const DummyAvatarAndName = ({ className }: ClassAttributes<HTMLElement> & Props) => (
  <Root className={className}>
    <DummyAvatar />

    <DummyName size="body2" length={75} />
  </Root>
);

const Root = styled('div')(
  gridLayoutContainer({
    columns: ['24px', `${SPACING_UNIT}px`, '1fr'],
    rows: ['auto'],
    areas: [['avatar', '.', 'name']],
  }),
);

const DummyAvatar = styled(DummyRectangle)(gridLayoutItem('avatar'), {
  width: 24,
  height: 24,
  borderRadius: '50%',
});

const DummyName = styled(DummyContent)(gridLayoutItem('name', { alignSelf: 'center' }));

export default DummyAvatarAndName;
